import SubscribeForm from './subscribe-form';

export default SubscribeForm;